<p>
    @for (range of openingRange(); track $index; let last = $last) {
        {{ range.start }} - {{ range.end }}
        @if (openingRange().length > 1 && !last) {
            <span>und</span>
        }
    }
</p>
